import React, { useState } from 'react';
import './UpgradeModal.css';
import PaymentForm from './PaymentForm';

function UpgradeModal({ isOpen, onClose, subscriptionInfo, user, onRefreshSubscription }) {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  if (!isOpen) return null;

  const handleUpgrade = () => {
    if (!user) {
      alert('Please sign in to upgrade to Pro');
      return;
    }
    setShowPaymentForm(true);
  };

  const handlePaymentSuccess = async () => {
    setShowPaymentForm(false);
    setShowSuccessModal(true);
    
    // Check Pro status and refresh subscription info immediately
    if (onRefreshSubscription) {
      // Check Pro status with the new simple system
      try {
        const response = await fetch('/api/subscription/check-status', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.userInfo.isPro) {
            console.log('Pro status confirmed, refreshing subscription info');
            onRefreshSubscription();
          }
        }
      } catch (error) {
        console.log('Pro status check failed:', error);
        // Still refresh to get updated info
        onRefreshSubscription();
      }
    }
  };

  const handlePaymentCancel = () => {
    setShowPaymentForm(false);
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    onClose();
  };

  const usageData = subscriptionInfo?.usage;

  // Success Modal
  if (showSuccessModal) {
    return (
      <div className="modal-overlay" onClick={handleSuccessClose}>
        <div className="upgrade-modal success-modal" onClick={(e) => e.stopPropagation()}>
          <div className="success-content">
            <div className="success-icon">🎉</div>
            <h2>Welcome to Swift Notes Pro!</h2>
            <p>Your subscription is now active and you have full access to all Pro features:</p>
            <ul className="pro-features-list">
              <li>✅ Unlimited notes per month</li>
              <li>✅ Unlimited folders</li>
              <li>✅ Ad-free experience</li>
              <li>✅ Unlimited speech-to-text</li>
              <li>✅ 10MB file attachments</li>
              <li>✅ Premium AI features</li>
            </ul>
            <button className="success-btn" onClick={handleSuccessClose}>
              Start Using Pro Features
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (showPaymentForm) {
    return (
      <div className="modal-overlay" onClick={handlePaymentCancel}>
        <div className="upgrade-modal payment-modal" onClick={(e) => e.stopPropagation()}>
          <div className="upgrade-header">
            <h2>Complete Your Upgrade</h2>
            <button className="modal-close-btn" onClick={handlePaymentCancel}>×</button>
          </div>
          
          <div className="upgrade-content">
            <PaymentForm 
              onSuccess={handlePaymentSuccess}
              onCancel={handlePaymentCancel}
              userEmail={user?.email}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <div className="upgrade-header">
          <h2>🚀 Upgrade to Pro</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="upgrade-content">
          <div className="current-usage">
            <h3>📊 Current Usage</h3>
            <div className="usage-stats">
              <div className="usage-item">
                <span className="usage-label">Notes this month:</span>
                <span className="usage-value">
                  {usageData?.notesThisMonth || 0} / {usageData?.notesLimit || 20}
                </span>
              </div>
              <div className="usage-item">
                <span className="usage-label">Folders:</span>
                <span className="usage-value">
                  {usageData?.foldersThisMonth || 0} / {usageData?.foldersLimit || 5}
                </span>
              </div>
            </div>
          </div>

          <div className="upgrade-benefits">
            <h3>✨ Pro Benefits</h3>
            <ul className="benefits-list">
              <li>🔄 Unlimited notes per month</li>
              <li>📁 Unlimited folders</li>
              <li>🚫 Ad-free experience</li>
              <li>🎤 Unlimited speech-to-text</li>
              <li>📎 10MB file attachments</li>
              <li>🔮 Premium features</li>
            </ul>
          </div>

          <div className="pricing-info">
            <div className="price-tag">
              <span className="price">Free Trial</span>
              <span className="period">/30 days</span>
            </div>
          </div>
        </div>

        <div className="upgrade-actions">
          <button className="upgrade-btn" onClick={handleUpgrade}>
            🚀 Start Free Trial
          </button>
          <button className="maybe-later-btn" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal; 